'use strict';

var container = [];
var qtyFormsContainer = [];

/**
 * A function to call the OrderGroove-PurchasePostTracking endpoint with the current OG optins.
 */
function onOptinChanged() {
    window.doOG(function () {
        $.ajax({
            url: window.OrdergrooveTrackingUrl,
            method: 'POST',
            data: { tracking: JSON.stringify(window.OG.getOptins()) },
            success: function () {
                // We want to trigger a quantity change event even though the quantity isn't changing
                // so that we execute the same logic that refreshes discounts when the quantity changes
                if (qtyFormsContainer && qtyFormsContainer.length > 0) {
                    for (var l = 0; l < qtyFormsContainer.length; l++) {
                        var qtyElement = qtyFormsContainer.pop();
                        qtyElement.find('.quantity-form > .quantity').trigger('change');
                    }
                }
                if (container && container.length > 0) {
                    for (var i = 0; i < container.length; i++) {
                        var element = container.pop();
                        element.find('.js-product-price').trigger('change');
                    }
                }
                $('#order-summary-block-id').load(' #order-summary-block-id > *');
            }
        });
    });
}

/**
 * Trigger onChange
 * @param {Element} $el - dom element
 */
function triggerOnChange($el) {
    window.doOG(function () {
        $el.find('og-optin-button:not([subscribed])').closest('.tile-body, .product-content').removeClass('og-selected');
        var $selectedOptins = $el.find('og-optin-button[subscribed]').closest('.tile-body, .product-content');
        if ($selectedOptins) {
            for (var i = 0; i <= $selectedOptins.length; i++) {
                var $selectedOptin = $($selectedOptins[i]);
                if ($selectedOptin && !$selectedOptin.hasClass('og-selected')) {
                    $selectedOptin.addClass('og-selected');
                    $selectedOptin.find('og-optin-button[subscribed]').trigger('click');
                }
            }
        }
    });
}

module.exports = function () {
    window.doOG(function () {
        if ((!window.OrdergrooveLegacyOffers) && window.OG) {
            window.OG.addOptinChangedCallback(onOptinChanged);
        }

        $('body').on('change', '.js-product-price', function () {
            var ogpid = $(this).data('ogpid');
            var allPrices = $('body').find('[data-ogpid="' + ogpid + '"]').toArray();
            var url = $(this).data('action');
            var isSubscriptionTrigger = false;
            var subscriptions = window.OG.getOptins();
            for (var i = 0; i < subscriptions.length; i++) {
                if (subscriptions[i].product === ogpid.toString()) {
                    isSubscriptionTrigger = true;
                    break;
                }
            }

            if (url) {
                url += isSubscriptionTrigger ? '&isSubscription=true' : '';
                $.ajax({
                    url: url,
                    type: 'get',
                    context: this,
                    dataType: 'json',
                    success: function (data) {
                        allPrices.forEach(function (priceContainer) {
                            $(priceContainer).empty().append(data.product.price.html);
                        });
                    },
                    error: function () { }
                });
            }
        });
    });

    $('body').on('click', 'og-optin-button, og-optout-button', function () {
        var $qtyFormsContainer = $(this).closest('.card.product-info');
        if ($qtyFormsContainer && $qtyFormsContainer.length > 0) {
            qtyFormsContainer.push($qtyFormsContainer);
        }
        $qtyFormsContainer = $(this).closest('.card .card-body');
        if ($qtyFormsContainer && $qtyFormsContainer.length > 0) {
            qtyFormsContainer.push($qtyFormsContainer);
            var product = $qtyFormsContainer.find('og-offer[product]').attr('product');
            var $gridContainer = $('.grid-tile.product[data-pid=' + product + ']');
            if ($gridContainer && $gridContainer.length > 0) {
                container.push($gridContainer.find('.product-tile'));
            }
            var $pdpContainer = $('.product-detail[data-pid=' + product + ']');
            if ($pdpContainer && $pdpContainer.length > 0) {
                container.push($pdpContainer);
            }
        }
        var $container = $(this).closest('.product-tile');
        $container.find('og-optin-button:not([subscribed])').closest('.tile-body, .product-content').removeClass('og-selected');
        $container.find('og-optin-button[subscribed]').closest('.tile-body, .product-content').addClass('og-selected');
        if (!$container || $container.length === 0) {
            $container = $(this).closest('.product-detail');
        }
        if ($container && $container.length > 0) {
            container.push($container);
        }
    });

    $('.og-offer, og-offer').ready(function () {
        triggerOnChange($(this));
    });

    $('body').on('change', '.og-offer, og-offer', function () {
        triggerOnChange($(this));
    });

    $(window).on('load', function () {
        triggerOnChange($(this));
    });

    // we need to trigger onOptinChanged to update JSON reference in basket
    window.bslReady(function () {
        window.doOG(function () {
            var cartPage = $('body').find('.container.cart-page');
            if (cartPage.length) {
                if (window.OG.getOptins().length) {
                    container.push(cartPage);
                    qtyFormsContainer.push(cartPage);
                    onOptinChanged();
                }
            }
        });
    });
};
